import React from 'react';
import { Link } from 'react-router';
import './notFound.css';

const NotFound = () => {
  return (
    <div className="ui center aligned text container not found grid">
      <div className="middle aligned row">
        <div className="column">
          <div className="ui segment">
            <h1 className="ui header">
              Catálogo Oficial da CARDS
              <div className="sub header">
                Futurecom Official Catalogue
              </div>
            </h1>
            <h2 className="ui huge header">
              404!
              <div className="sub header">
                Página não encontrada.
                <br />
                <small>Page not found.</small>
              </div>
            </h2>
          </div>
          <Link to="/" className="ui big icon labeled blue button">
            <i className="arrow left icon" />
            Voltar<small> / Back</small>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;



/** WEBPACK FOOTER **
 ** ./src/components/screens/notFound/NotFound.js
 **/